
























































































































import {Component} from 'vue-property-decorator';
import {ValidationObserver} from 'vee-validate';
import LoadingMixin from '@/mixins/LoadingMixin';
import {mixins} from 'vue-class-component';
import Swal from 'sweetalert2';
import {swalWarning, swalSuccess} from '@/plugins/swal';

@Component
export default class FormRegister extends mixins(LoadingMixin) {
  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
  };
  username = '';
  password = '';
  location = '';
  show2 = false;
  show = false;
  checkbox = true;
  revealPassword = false;
  isLoading = false;
  form = {
    name: '',
    phonenumber1: '',
    nik: '',
    email: '',
    password: '',
    repassword: '',
  };

  get rules() {
    return {
      name: 'required',
      phonenumber1: 'required|phone|numeric',
      nik: 'required|min:16|max:16',
      email: 'required|email',
      password: 'required|format_password',
      tmc: 'required',
      repassword: 'required|confirmed:password|format_password',
    };
  }

  async onSubmit() {
    try {
      this.isLoading = true;
      this.$alert.hide();
      this.$snackbar.hide();

      this.startLoading();
      const res = await this.$store.dispatch('auth/register', this.form);
      this.finishLoading();
      if (res.status === 200) {
        const responseMail = await this.$store.dispatch('auth/registerMail', {
          send_to: res.data.user.email,
          send_name: res.data.user.name,
          verified_status: 1,
          user_id: res.data.user.id, // user_id
        });

        if (responseMail.status === 200) {
          this.isLoading = false;
          swalSuccess.fire({
            title: 'Success!',
            text: res.data.message,
          });
          this.location =
            new URL(window.location.href).searchParams.get('source') || '';

          const query: {logged_out: string; source?: string} = {
            logged_out: '1',
          };

          // Tambahkan 'source' ke query jika ada nilainya
          if (this.location) {
            query.source = this.location;
          }

          this.$router.push({
            name: 'login',
            query: query,
          });
        }
      } else {
        this.isLoading = false;
        swalWarning.fire({
          title: 'Failed!',
          text: res.errors[0].message,
        });
      }
    } catch (e) {
      this.$alert.error(e.response.errors[0]?.message || e.response?.message);
    }
  }
}
